<script setup lang="ts">
const properties = defineProps<{ text: string; query: string }>();
</script>

<template>
  <span>
    <template
      v-for="(segment, i) in useHighlight(properties.text, properties.query)"
      :key="i"
    >
      <strong v-if="segment.bold">
        {{ segment.text }}
      </strong>
      <template v-else>
        {{ segment.text }}
      </template>
    </template>
  </span>
</template>
